export default __webpack_public_path__ + "static/media/pfdintextpro-regular-webfont.bac88338.woff";